import React from "react";
import { Link } from "react-router-dom";
import BaraLogo from "./Logo/BaraLogo";
import "./Style/footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <div className="footer-container">
      <div className="footer-brand">
        <Link to="/" className="footer-logo-link" aria-label="Bara — Home">
          <BaraLogo height={32} color="#111111" />
        </Link>
      </div>

      <div className="icons">
        <a href="https://www.linkedin.com/company/bara-engineering-bv/">
          <i className="fa-brands fa-linkedin"></i>
        </a>
      </div>

      <div className="line">
        <hr />
      </div>

      <div className="copyright">
        <p>All Rights Reserved &copy; Bara Company B.V. {currentYear}</p>
      </div>
    </div>
  );
};

export default Footer;
